import classNames from "classnames";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";

const Rgpd = ({ title, sections, footer, text, className }) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("RGPD", { returnObjects: true });
  const [expanded, setExpanded] = useState(false);

  const resolvedTitle = title || TRANSLATION?.TITLE;
  const resolvedSections =
    sections ||
    TRANSLATION?.SECTIONS ||
    [
      {
        label: TRANSLATION?.RESPONSIBLE,
        text: TRANSLATION?.TEXT,
      },
    ].filter(({ label, text: body }) => label || body);
  const resolvedFooter = footer !== undefined ? footer : TRANSLATION?.FOOTER;
  const hasCustomText = text != null;

  return (
    <div className={classNames("acoris-rgpd", className)}>
      <div
        className={classNames("acoris-rgpd__content", {
          "acoris-rgpd__content--expanded": expanded,
          "acoris-rgpd__content--collapsed": !expanded && hasCustomText,
        })}
      >
        {resolvedTitle && <p className="acoris-rgpd__title">{resolvedTitle}</p>}

        {hasCustomText ? (
          <div className="acoris-rgpd__text">{text}</div>
        ) : (
          <>
            {(expanded ? resolvedSections : resolvedSections.slice(0, 1)).map(
              ({ label, text: body }, index) => (
                <p key={`${label}-${index}`} className="acoris-rgpd__section">
                  {label && (
                    <strong className="acoris-rgpd__label">{label}</strong>
                  )}
                  {body && (
                    <span className="acoris-rgpd__body">{` ${body}`}</span>
                  )}
                </p>
              ),
            )}
            {expanded &&
              resolvedFooter &&
              (typeof resolvedFooter === "string" ? (
                <p
                  className="acoris-rgpd__footer"
                  dangerouslySetInnerHTML={{ __html: resolvedFooter }}
                />
              ) : (
                <p className="acoris-rgpd__footer">{resolvedFooter}</p>
              ))}
          </>
        )}
      </div>

      <button
        type="button"
        className="acoris-rgpd__toggle"
        onClick={() => setExpanded((prev) => !prev)}
      >
        {expanded
          ? TRANSLATION?.CLOSE || "Fermer"
          : TRANSLATION?.READ_MORE || "Lire la suite"}
      </button>
    </div>
  );
};

Rgpd.propTypes = {
  title: PropTypes.string,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
};

export default Rgpd;
